export const marketPulseTheme = {
  cardGradient:
    "linear-gradient(-27.31deg, #426EEE 0%, #122DB2 57.69%, #426EEE 100%)",
  cardRadius: "0 0 20px 20px",
  cardBorder: "1px solid #393939",
  cardShadow:
    "0px 2px 4px -2px rgba(0,0,0,0.1), 0px 4px 6px -1px rgba(0,0,0,0.1), inset 0px 0px 28px 0px rgba(52,101,255,0.5)",
  cardBackdrop: "blur(16px)",

  glassPanelGradient:
    "linear-gradient(-83.93deg, rgba(255,255,255,0.1) 12.1%, rgba(251,251,251,0.1) 46.21%, rgba(255,255,255,0.1) 87.9%)",
  glassPanelRadius: "10.125px",
  glassBackdrop: "blur(5.25px)",

  pillWidth: 244,
  pillFaceHeight: 66,
  pillFaceGradient:
    "linear-gradient(107.94deg, #4D7DFC 0%, #0E28AD 37.95%, #4272FF 71.58%, #2456FE 99.91%)",
  pillFaceRadius: "12px 12px 22px 22px",
  pillFaceInset: "inset 0px 2px 3px 0px #102CB2",
  pillBaseColor: "#07038D",
  pillBaseRadius: "22px",
  pillBaseInset: "inset 0px -16px 4px 0px rgba(0, 0, 0, 0.25)",
  pillSeparator: "rgba(255, 255, 255, 0.55)",
  pillTitleColor: "#F5F5F5",
  pillSubtitleColor: "#FFFFFF",

  glassPanel: "rgba(255, 255, 255, 0.1)",
  glassBorder: "rgba(255, 255, 255, 0.1)",

  textPrimary: "#FFFFFF",
  textSecondary: "rgba(255, 255, 255, 0.9)",
  textMuted: "rgba(255, 255, 255, 0.62)",
  designation: "#D0D0D0",
  profileName: "#F5F5F5",

  statusPillBg:
    "linear-gradient(90deg, rgba(0,201,80,0.1) 0%, rgba(0,188,125,0.1) 100%)",
  statusPillBorder: "0.667px solid rgba(0,201,80,0.2)",
  statusDot: "#00C950",
  statusText: "#05DF72",

  dateBoxBg: "rgba(255, 255, 255, 0.05)",
  dateBoxBorder: "0.667px solid rgba(255, 255, 255, 0.1)",
  dateText: "#8EC5FF",

  outlookBg:
    "linear-gradient(90deg, rgba(254,154,0,0.1) 0%, rgba(255,105,0,0.1) 100%)",
  outlookBorder: "0.667px solid rgba(254,154,0,0.2)",
  outlookTitle: "#FFD230",

  audioBarBg: "transparent",
  audioBarBorder: "transparent",
  playGradient: "linear-gradient(90deg, #2B7FFF 0%, #155DFC 100%)",
  playShadow:
    "0px 10px 15px rgba(43,127,255,0.3), 0px 4px 6px rgba(43,127,255,0.3)",
  waveformActive: "#22C55E",
  waveformIdle: "rgba(255, 255, 255, 0.28)",
  controlBtnBg: "rgba(255, 255, 255, 0.05)",
  controlBtnBorder: "0.667px solid rgba(255, 255, 255, 0.1)",

  navBtnBg: "rgba(255, 255, 255, 0.1)",
  navBtnHover: "rgba(255, 255, 255, 0.18)",

  chartWidth: 182,
  chartHeight: 224,
  chartRadius: "20px",

  disclaimer: "rgba(255, 255, 255, 0.85)",
};
